export const EMPLOYEE_WORKING_HOURS_TOGGLE_STORAGE_KEY = 'hide-non-working';

export const EMPLOYEE_WORKING_HOURS_TOGGLE_FEATURE = 'toggle-cal-employees';
